import { render, staticRenderFns } from "./MemogeniusArticlePopup.vue?vue&type=template&id=0714b23d&scoped=true&"
import script from "./MemogeniusArticlePopup.vue?vue&type=script&lang=js&"
export * from "./MemogeniusArticlePopup.vue?vue&type=script&lang=js&"
import style0 from "./MemogeniusArticlePopup.vue?vue&type=style&index=0&id=0714b23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714b23d",
  null
  
)

export default component.exports